import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import moment from 'moment';
import VendorInvoice from 'src/models/AP/VendorInvoice';
import Vendor from 'src/models/AP/Vendor';

interface IAddVendorInvoicesDialogProps {
    newVoucher?: boolean;
    dialogName: string;
    invoices: Array<VendorInvoice>;
    onCreateVoucher?: (invoices: VendorInvoice[]) => void;
    onCancel?: () => void;
    onUpdateVoucher?: (invoices: VendorInvoice[]) => void;
    setVoucherInvoices?: (invoices: Array<VendorInvoice>) => void;
    voucherNumber: number | string;
    vendor?: Vendor;
    hideDialog: () => void;
    onCreateInvoice?: (invoice: VendorInvoice) => void;
    onDeleteInvoice?: (invoiceId: number) => void;
}

const AddVendorInvoicesDialog = (props: IAddVendorInvoicesDialogProps) => {
    const { register, reset, errors, getValues, setValue } = useForm();
    const [invoices, setInvoices] = useState<Array<VendorInvoice>>(undefined);
    const [selectedInvoice, setSelectedInvoice] = useState<number>(-1);
    const [invoiceNumberElementStyle, setInvoiceNumberElementStyle] = useState<string>('padding: 0');
    const [invoiceAmountElementStyle, setInvoiceAmountElementStyle] = useState<string>('padding: 0');
    const [invoiceDateElementStyle, setInvoiceDateElementStyle] = useState<string>('padding: 0');

    // const [invoiceTotal, setInvoiceTotal] = useState<number>(undefined);
/*     const [invoices, setInvoices] = useState<VendorInvoice[]>([
        { id: 1, vendorNumber: 4934, vendorName: 'American Abstract LLC', invoiceNumber: 3152, invoiceAmount: 15.62, invoiceDate: moment(new Date).format('YYYY-MM-DD') as unknown as Date },
        { id: 2, vendorNumber: 4934, vendorName: 'American Abstract LLC', invoiceNumber: 3153, invoiceAmount: 73.49, invoiceDate: moment(new Date).format('YYYY-MM-DD') as unknown as Date },
        { id: 3, vendorNumber: 4934, vendorName: 'American Abstract LLC', invoiceNumber: 3154, invoiceAmount: 8.14, invoiceDate: moment(new Date).format('YYYY-MM-DD') as unknown as Date },
        { id: 4, vendorNumber: 4934, vendorName: 'American Abstract LLC', invoiceNumber: 3155, invoiceAmount: 12.82, invoiceDate: moment(new Date).format('YYYY-MM-DD') as unknown as Date },
    ]); */

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('FindVendorDialog onCreate()');
        calculateTotal();
    };

    useEffect(() => {
        if (selectedInvoice !== -1) {
            console.log(selectedInvoice);
        }
    }, [selectedInvoice]);

    useEffect(() => {
        if (!!invoices && invoices.length > 0) {
            calculateTotal();
        }
    }, [invoices]);

    useEffect(() => {
        if (!!props?.vendor) {
            console.log(props.vendor.vendorName);
        }
    }, [props?.vendor]);

    useEffect(() => {
        if (Number(props?.voucherNumber) > 0) {
            console.log('existing voucher');
        }
    }, [props?.voucherNumber]);

    useEffect(() => {    
        if (!!props.invoices) {
            setInvoices(props.invoices);
        }
    }, [props.invoices]);

    const OKClicked = () => {
        props.setVoucherInvoices(invoices);
        props.onCreateVoucher(invoices);
        props.hideDialog();
    };

    const CancelClicked = () => {
        setInvoices([]);
        props.onCancel();
    };

    const calculateTotal = () => {
        if (invoices?.length) {
            let invoiceTotal = 0;
            invoices.forEach(invoice => {
                invoiceTotal += parseFloat(invoice.amount + '');
            });

            setValue('total', invoiceTotal);
        }
    };

    const addVendorInvoice = () => {
        let values = getValues();
        let invoiceNumberInputElement = document.getElementById(`vendorInvoiceForm.InvoiceNumber`) as HTMLInputElement;
        let invoiceDateInputElement = document.getElementById(`vendorInvoiceForm.InvoiceDate`) as HTMLInputElement;
        let invoiceAmountInputElement = document.getElementById(`vendorInvoiceForm.invoiceAmount`) as HTMLInputElement;
        const errorElement = document.getElementById(`addInvoiceDialogError`);
        if (invoiceNumberElementStyle === 'padding: 0') {
            setInvoiceNumberElementStyle(invoiceNumberInputElement.style.cssText);
        }
        if (invoiceDateElementStyle === 'padding: 0') {
            setInvoiceDateElementStyle(invoiceDateInputElement.style.cssText);
        }
        if (invoiceAmountElementStyle === 'padding: 0') {
            setInvoiceAmountElementStyle(invoiceAmountInputElement.style.cssText);
        }

        let invoice: VendorInvoice = {
            voucherNumber: !props.newVoucher ? props.voucherNumber : '0',
            vendorNumber: values.vendorNumber ? Number(values.vendorNumber) : 0,
            vendorName: values.vendorName ? values.vendorName : '',
            number: values.invoiceNumber ? values.invoiceNumber : 0,
            amount: values.invoiceAmount ? Number(values.invoiceAmount) : 0,
            date: values.invoiceDate ? values.invoiceDate : null
        };

        let errorText = '';

        if (!invoice.vendorNumber || !invoice.vendorName || !invoice.number || !invoice.amount || !invoice.date) {
            errorText = 'Invoice';
            // window.alert('Information Missing');
            if (!invoice.number) {
                invoiceNumberInputElement.setAttribute('style', 'border: solid 1px red');
                errorElement.setAttribute('style', 'display: block; color: red');
                errorText += ' Number';
            } else {
                invoiceNumberInputElement.setAttribute('style', invoiceNumberElementStyle);
            }
            if (!invoice.amount) {
                invoiceAmountInputElement.setAttribute('style', 'border: solid 1px red');
                errorElement.setAttribute('style', 'display: block; color: red');
                errorText += (errorText === 'Invoice' ? ' Amount' : ', Amount');
            } else {
                invoiceAmountInputElement.setAttribute('style', invoiceAmountElementStyle);
            }
            if (!invoice.date) {
                invoiceDateInputElement.setAttribute('style', 'border: solid 1px red');
                errorElement.setAttribute('style', 'display: block; color: red');
                errorText += (errorText === 'Invoice' ? ' Date' : ', Date');
            } else {
                invoiceDateInputElement.setAttribute('style', invoiceDateElementStyle);
            }
            if (errorText !== '') {
                errorText += ' required.';
                errorElement.innerText = errorText;
            }
        } else {
            // Todo: search invoices to make sure this one is not already in there
            const existingInvoiceNumber = invoices?.find((vi: VendorInvoice) =>
                invoice?.number === vi?.number
            );
            if (!existingInvoiceNumber) {
                invoiceNumberInputElement.setAttribute('style', invoiceNumberElementStyle);
                errorElement.setAttribute('style', 'display: none');
                let newInvoices = (!!invoices && invoices.length > 0) ? [...invoices] : [];
                newInvoices.push(invoice);
                setInvoices(newInvoices);
                // reset(invoices);
                if (!props.newVoucher) {
                    props.onCreateInvoice(invoice);
                }
                invoiceNumberInputElement.value = '';
                invoiceDateInputElement.value = 'mm/dd/yyyy';
                invoiceAmountInputElement.value = '';
                invoiceNumberInputElement.setAttribute('style', invoiceNumberElementStyle);
                invoiceAmountInputElement.setAttribute('style', invoiceAmountElementStyle);
                invoiceDateInputElement.setAttribute('style', invoiceDateElementStyle);
                errorElement.setAttribute('style', 'display: none');
            } else {
                invoiceNumberInputElement.setAttribute('style', 'border: solid 1px red');
                errorElement.setAttribute('style', 'display: block; color: red');
                errorElement.innerText = 'There is already an invoice with ' + invoice?.number + '.';
            }
        }
    };

    const removeVendorInvoice = (index: number) => {
        if (invoices.length > 0 && index >= 0) {
            if (!props.newVoucher) {
                props.onDeleteInvoice(invoices[index]?.id);
            } else {
                let newInvoices = [...invoices];
                newInvoices.splice(index, 1);
                setInvoices(newInvoices);
                reset(newInvoices);
            }
        }
    };

    return (
        <Dialog title="Add Vendor Invoices" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '50%' }}>
            <p id="addInvoiceDialogError" style={{display: 'none', color: 'red'}}/>
            <div style={{paddingTop: '2rem'}}>
                <RHFInputBox
                    id={`vendorInvoiceForm.InvoiceNumber`}
                    labelOnLeft={true}
                    labelStyle={{width: '20rem'}}
                    label="Enter Vendor Invoice Number"
                    name={`invoiceNumber`}
                    type="text"
                    register={register}
                    errors={errors}
                />
                <RHFInputBox
                    id={`vendorInvoiceForm.InvoiceDate`}
                    labelOnLeft={true}
                    labelStyle={{width: '20rem'}}
                    label="Invoice Date"
                    name={`invoiceDate`}
                    type="date"
                    register={register}
                    errors={errors}
                />
                <div className="form-row" style={{marginBottom: '0'}}>
                    <RHFInputBox
                        id={`vendorInvoiceForm.invoiceAmount`}
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        label="Invoice Amount"
                        name={`invoiceAmount`}
                        type="number"
                        register={register}
                        errors={errors}
                    />
                    <Button 
                        className="blue-hover-button" 
                        style={{ width: '20rem', height: '3rem', marginRight: '6.5rem' }} 
                        text={'Add Invoice'}
                        onClick={() => addVendorInvoice()}
                    />
                </div>
                <div className="form-row">
                    <RHFInputBox 
                        labelOnLeft={true} 
                        labelStyle={{width: '20rem'}} 
                        label="Vendor Number" 
                        name={'vendorNumber'} 
                        type="text"
                        register={register}
                        errors={errors}
                        defaultVal={invoices?.length > 0 ? invoices[0]?.vendorNumber.toString() : (!!props?.vendor?.vendorNumber ? props?.vendor?.vendorNumber.toString() : '')}
                    />
                    <RHFInputBox 
                        labelOnLeft={true} 
                        label="Name" 
                        name={'vendorName'} 
                        type="text" 
                        style={{width: '70%'}}
                        register={register}
                        errors={errors}
                        defaultVal={invoices?.length > 0 ? invoices[0]?.vendorName : (!!props?.vendor?.vendorName ? props?.vendor?.vendorName : '')}
                    />
                </div>
                <div style={{marginTop: '3rem', overflowY: 'scroll', height: '20rem'}}>
                    <form>
                        <table style={{width: '100%'}}>
                            <thead style={{ textAlign: 'left' }}>
                                <tr>
                                    <th>Vendor Invoice Number</th>
                                    <th>Invoice Date</th>
                                    <th>Invoice Amount</th>
                                </tr>
                            </thead>
                            {invoices && invoices?.map((invoice: VendorInvoice, index: number) => {
                                return (
                                    <tbody key={invoice.id}>
                                        <tr onClick={() => setSelectedInvoice(index)} className="table-item-hover" style={{ textAlign: 'left' }}>
                                            <td style={{ width: '50%' }}>
                                                <RHFInputBox
                                                    name={`invoices[${index}].invoiceNumber`}
                                                    type="text"
                                                    defaultVal={invoice.number + ''}
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '100%' }}
                                                />
                                            </td>
                                            <td style={{ width: '20%' }}>
                                                <RHFInputBox 
                                                    name={`invoices[${index}].invoiceDate`}
                                                    type="date"
                                                    defaultVal={`${moment(invoice.date).format('YYYY-MM-DD') as unknown as Date}`}
                                                    errors={errors}
                                                    style={{width: '100%'}}
                                                    bodyStyle={{width: '100%'}}
                                                />
                                            </td>
                                            <td style={{ width: '25%' }}>
                                                <RHFInputBox
                                                    name={`invoices[${index}].invoiceAmount`}
                                                    type="number"
                                                    defaultVal={invoice.amount + ''}
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '100%' }}
                                                />
                                            </td>
                                            <td style={{ width: '5%' }}>
                                                <Button 
                                                    reactIcon={IoMdCloseCircleOutline} 
                                                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                    iconHoverColor="red"
                                                    title="Remove Vendor Invoice"
                                                    style={{ height: '3rem', background: 'transparent' }} 
                                                    onClick={() => removeVendorInvoice(index)}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                    );
                                })}
                        </table>
                    </form>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2rem' }}>
                    <RHFInputBox
                        label="Total"
                        labelOnLeft={true}
                        name={`total`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%', border: '2px solid black' }}
                        bodyStyle={{ width: '30%', marginRight: '5rem' }}
                    />
                </div>
                <div className="form-row" style={{marginTop: '2rem', marginLeft: '27%', textAlign: 'center'}}>
                    <Button
                        className="blue-hover-button"
                        style={{ width: '30%', marginRight: '1rem' }}
                        text={!!props.newVoucher ? 'Finish Voucher' : 'Close'}
                        onClick={OKClicked}
                    />
                    <Button
                        className="blue-hover-button"
                        style={{ width: '30%', marginRight: '1rem' }}
                        text={'Cancel'}
                        onClick={() => CancelClicked()}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default AddVendorInvoicesDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/AddVendorInvoicesDialog.tsx